const PaymentButton = ({ isProcessing, startPayment }) => {
  return (
    <div className="root_track">
      <button
        className="payment-btn"
        onClick={startPayment}
        disabled={isProcessing}
        type="button"
      >
        {isProcessing ? "Processing..." : "Proceed to Payment"}
      </button>
    </div>
  );
};
export default PaymentButton;